import React, { Component } from 'react';
import { ResponsiveContainer, Legend, Bar, BarChart, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import { connect } from "react-redux";
import { getVunnenChartByUserid,setofUpdatedashboard } from 'actions'
import {isEmpty,isUndefined} from 'lodash'
import {NumberFormat} from 'components/NotyNumberFormat'
import moment from 'moment'
import Skeleton from '@material-ui/lab/Skeleton';
import { injectIntl } from 'react-intl';
import compose from 'recompose/compose';
import IntlMessages from 'util/IntlMessages';

const renderColorfulLegendText = (value, entry) => {
  const { color } = entry;
  return <span style={{ color }}>{value}</span>;
}

class Diagram extends Component {
  state={
    DashboardAnpassadFilterOption:[],
    done: true
  }
  intervalID = null
  componentDidMount=()=>{
    const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        this.props.getVunnenChartByUserid(userid,Afid,this.props.DashboardAnpassadFilterOption)
        .then(() => {
          this.initiateInterval() 
      //    this.setState({done: true})   
      })
    }
    initiateInterval() {
        clearInterval(this.intervalID);
        this.intervalID= null
    this.intervalID = setInterval(
      () => {
        if(this.state.done === true){            
        //  this.setState({done: false}) 
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        this.props.getVunnenChartByUserid(userid,Afid,this.props.DashboardAnpassadFilterOption)
        .then(() => {
          this.initiateInterval() 
        //  this.setState({done: true})   
      })
    }
      },
      180000
  );
   
}
componentWillUnmount() {
  clearInterval(this.intervalID);
  this.intervalID= null
}
componentDidUpdate=()=>{
  const userid = this.props.authUser.user_id;
  const Afid = this.props.authUser.user_Afid;
  if(parseInt(this.props.updatedashboard) === 1){
    this.props.getVunnenChartByUserid(userid,Afid,this.props.DashboardAnpassadFilterOption)  /**/
    .then(() => {
      this.initiateInterval() 
     // this.setState({done: true})   
  })
    this.props.setofUpdatedashboard()
}
}
createData=()=>{
  let data = []
  if(isEmpty(this.props.VunnenChart)){data= [
    { name: "JAN", Värde:0 },
    { name: "FEB", Värde:0 },
    { name: "MAR", Värde:0 },
    { name: "APR", Värde:0 },
    { name: "MAJ", Värde:0 },
    { name: "JUN", Värde:0 },
    { name: "JUL", Värde:0 },
    { name: "AUG", Värde:0 },
    { name: "SEP", Värde:0 },
    { name: "OKT", Värde:0 },
    { name: "NOV", Värde:0 },
    { name: "DEC", Värde:0 },
  ]}
  else{
    data= [
      { name: "JAN", 
        Värde:this.props.VunnenChart.filter(n=>{return n.Meta === "JAN"})[0].Value
      },
      { name: "FEB", Värde:this.props.VunnenChart.filter(n=>{return n.Meta === "FEB"})[0].Value },
      { name: "MAR", Värde:this.props.VunnenChart.filter(n=>{return n.Meta === "MAR"})[0].Value },
      { name: "APR", Värde:this.props.VunnenChart.filter(n=>{return n.Meta === "APR"})[0].Value },
      { name: "MAJ", Värde:this.props.VunnenChart.filter(n=>{return n.Meta === "MAJ"})[0].Value },
      { name: "JUN", Värde:this.props.VunnenChart.filter(n=>{return n.Meta === "JUN"})[0].Value },
      { name: "JUL", Värde:this.props.VunnenChart.filter(n=>{return n.Meta === "JUL"})[0].Value },
      { name: "AUG", Värde:this.props.VunnenChart.filter(n=>{return n.Meta === "AUG"})[0].Value },
      { name: "SEP", Värde:this.props.VunnenChart.filter(n=>{return n.Meta === "SEP"})[0].Value },
      { name: "OKT", Värde:this.props.VunnenChart.filter(n=>{return n.Meta === "OKT"})[0].Value },
      { name: "NOV", Värde:this.props.VunnenChart.filter(n=>{return n.Meta === "NOV"})[0].Value },
      { name: "DEC", Värde:this.props.VunnenChart.filter(n=>{return n.Meta === "DEC"})[0].Value },
    ]
  }
  //
  let ShortStartMonth = isUndefined(this.props.StartMonth)?"Januari":this.props.StartMonth.slice(0,3).toUpperCase()
  console.log(ShortStartMonth)
  let ShortStartMonthIndex = data.findIndex(i => i.name === ShortStartMonth)
  console.log(ShortStartMonthIndex)
  let RotateArr = this.DoRotete(data,12-ShortStartMonthIndex)
  console.log(RotateArr)
  //
  return data
}
DoRotete = (data,ShortStartMonthIndex)=>{
  let i = 0
  while(i < ShortStartMonthIndex){
    data.unshift(data.pop())
    i++
  }
  return data
}
getDashBoardValueOf = ()=>{
  try{
  let ModuleValue = JSON.parse(this.props.DashBoardValueOf).find(item=>parseInt(item.DashBaord) === 1)
  if(ModuleValue.Value > 2 && ModuleValue.Value !== 5){
      return 2
  }else{
      return 1
  }
}
catch(error){return 1}
}

formatNumber=(number)=>{
  const _ValueOF = this.getDashBoardValueOf()
  return NumberFormat(number, _ValueOF === 2?'total':this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', _ValueOF === 2?'default':'auto', 0)
  return NumberFormat(number, this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', 'auto', 0)
  if(number > 1000000){
    return `${(number/1000000).toFixed(0)}M`
}else if(number >= 1000){
    return `${(number/1000).toFixed(0)}K`
}else{
  return isEmpty(number)?0:Number(number).toFixed(0)
}
}
formatNumber2=(number)=>{
  const _ValueOF = this.getDashBoardValueOf()
  return NumberFormat(number, _ValueOF === 2?'total':this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', _ValueOF === 2?'default':'auto', 0)
  return NumberFormat(number.toFixed(0), 'standard', 'auto', 0)
  console.log(number)
  try{
    return `${isUndefined(number)?0:number.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`
  }catch(error){
    return 0
  }
  
}
render() {
  console.log('test83373673', this.props)
  const formatter = new Intl.NumberFormat('fr',{ notation: "compact" , compactDisplay: "short" })
  return (<>{
    this.state.done === false?
    <Skeleton variant="rectangular"  height={278} style={{margin:'auto 10px',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
    :
    <div className='p-2 d-flex flex-column align-items-center justify-content-around h-100'>
        <svg width="300" height="300" style={{position: 'absolute', pointerEvents: 'none', left: '0'}}>
          <linearGradient id="linearColors6"  x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor="#5CD1D1" />
          <stop offset="100%" stopColor="#21A1A7" />
          </linearGradient>
        </svg>
      <div style={{color:  isUndefined(this.props.FontColor)?'#fff':this.props.FontColor,margin:"0", textAlign: 'center'}}>
        <h3 style={{ color:  isUndefined(this.props.FontColor)?'#fff':this.props.FontColor, fontSize: this.props.height === 110 ? "2rem" : "3rem",margin:0,fontWeight:"400" }}>{this.formatNumber2(this.props.VunnenYear)}</h3>
        <p style={{ marginTop: '-5px' }}><IntlMessages id="DashBoard.Total.salling"/> {
          isEmpty(this.props.DashboardAnpassadFilterOption.filter(item =>{
            return item.Meta ==='DatumFrom'
          }))?moment(new Date()).format("YYYY"):
          moment(this.props.DashboardAnpassadFilterOption.filter(item =>{
            return item.Meta ==='DatumFrom'
          })[0].Value).format("YYYY")
        }</p>
      </div>
      <div style={{ color: '#fff' }} className="w-100">
        <ResponsiveContainer className="gx-barchart" width="98%" height={this.props.height > 1 ? this.props.height : 180}>
        {/* <ResponsiveContainer className="gx-barchart" width="95%" style={{ height:isEmpty(this.props.height) ? 180 : this.props.height }} > */}
          <BarChart
            data={this.createData()}
            margin={{ top: 0, right: 0, left: this.props.Flags?.DashboardRoundoff === 0 ? 20 : 0, bottom: 0 }}
          >
            <XAxis stroke={ isUndefined(this.props.FontColor)?'#fff':this.props.FontColor} tick={{ fill:  isUndefined(this.props.FontColor)?'#fff':this.props.FontColor }} dataKey="name" fontSize={11}/>
            <YAxis stroke={ isUndefined(this.props.FontColor)?'#fff':this.props.FontColor} tick={{ fill:  isUndefined(this.props.FontColor)?'#fff':this.props.FontColor }} type="number" tickFormatter={tick => {
              return this.formatNumber(tick)
            }}/>
            {/* <CartesianGrid strokeDasharray="0" stroke="#44D1C280" /> */}
            <Tooltip cursor={{ stroke: '#0E898F40', strokeWidth: 1, fill: "#0E898F40" }} 
            formatter={(value) => `${this.formatNumber2(value)}`} 
            labelStyle={{ color: "#075A5F" }}
            itemStyle={{ color: "#075A5F" }} />
            {/* <Legend style={{color: '#fff'}} iconType="circle" /> */}
            <Legend formatter={renderColorfulLegendText} iconType="circle" />
            <Bar
              name={this.props.intl.formatMessage({ id: 'Value' })}
              dataKey="Värde"
              barSize={10} 
              radius={[30, 30, 0, 0]}
              // fill="#075a5f"
              // fill="#44D1C2"
              fill="url(#linearColors6)"
              // style={{color: '#fff'}}
            />
            </BarChart>

        </ResponsiveContainer>
      </div>
    </div>}</>
  );
}
};

const mapStateToProps = ({ settings,auth,DashBoard,accountsData }) => {
  const { width } = settings;
  const { Flags,updatedashboard,DashBoardValueOf} = accountsData
  const { authUser} = auth;
  const { VunnenChart,VunnenYear,DashboardAnpassadFilterOption,StartMonth} = DashBoard;
  return { width,authUser,VunnenChart,VunnenYear,DashboardAnpassadFilterOption,StartMonth,Flags,updatedashboard,DashBoardValueOf };
};
function mapDispatchToProps(dispatch) {
  return {
    getVunnenChartByUserid: (userid,Afid,DashboardAnpassadFilterOption) => dispatch(getVunnenChartByUserid(userid,Afid,DashboardAnpassadFilterOption)),
    setofUpdatedashboard: () => dispatch(setofUpdatedashboard()),
      dispatch
  }
}
export default compose(
  connect(mapStateToProps,mapDispatchToProps),
  injectIntl
)(Diagram);
